import React, { useState, useEffect } from 'react';
import { Box, Alert, AlertTitle, Snackbar, Stack } from '@mui/material';
import alertSystem from '../utils/alerts.js';

const AlertDisplay = () => {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    // Subscribe to alert system updates
    const unsubscribe = alertSystem.subscribe((newAlerts) => {
      setAlerts(newAlerts);
    });

    // Get initial alerts
    setAlerts(alertSystem.getAlerts());

    // Cleanup subscription on unmount
    return unsubscribe;
  }, []);

  const handleClose = (alertId) => {
    alertSystem.removeAlert(alertId);
  };

  const getAlertSeverity = (type) => {
    switch (type) {
      case 'success':
        return 'success';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'info';
    }
  };

  const getAlertIcon = (type) => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return 'ℹ️';
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 80,
        right: 20,
        zIndex: 9999,
        width: '350px',
        maxWidth: '90vw',
      }}
    >
      <Stack spacing={1}>
        {alerts.map((alert) => (
          <Snackbar
            key={alert.id}
            open={true}
            autoHideDuration={null}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <Alert
              severity={getAlertSeverity(alert.type)}
              onClose={() => handleClose(alert.id)}
              sx={{
                width: '100%',
                boxShadow: 3,
                '& .MuiAlert-message': {
                  fontWeight: 500,
                },
              }}
            >
              <AlertTitle sx={{ fontWeight: 'bold' }}>
                {getAlertIcon(alert.type)} {alert.type.charAt(0).toUpperCase() + alert.type.slice(1)}
              </AlertTitle>
              {alert.message}
            </Alert>
          </Snackbar>
        ))}
      </Stack>
    </Box>
  );
};

export default AlertDisplay; 